<script>
import draggable from 'vuedraggable'
export default {
	data() {
		return {
			drag: true,
			submitData: {
				title: 123
			},
			loading: false,
			closeIsActive: false,
			questionType: 1
		};
	},
	computed: {
		submitRules() {
			return {
				title: [
					{
						required: true,
						message: '請填寫問題標題',
					},
				],
			}
		},
	},
	created() { },
	mounted() { },
	methods: {
		addNewGroup() { },
		onClickButton() { },
		onClickSave() { },
		typeChanged() { },
		/**
 * @description 問題形式
 */
		typeSelect(type) {
			const typeList = {
				'checkbox': '複選',
				'text': '簡答',
				'radio': '單選'
			}
			return typeList[type]
		},
		openCloseCard() {
			this.closeIsActive = !this.closeIsActive
		},
	},
	components: {
		draggable,
	},
};
</script>


<template>
	<div>
		<div :class="$style.stage">
			<el-row :gutter="20" :class="$style.questionSet">
				<el-col :span="12">
					<h4>題目設定</h4>
				</el-col>
				<el-col :span="12">
					<el-button class="is-round" type="primary" plain @click="addNewGroup">
						<BaseIcon name="plus" />
						<span>新增題目</span>
					</el-button>
				</el-col>
			</el-row>
			<div>
				<draggable animation="200" handle=".handle-subject" @start="drag = true" @end="drag = false">
					<transition-group type="transition" :name="!drag ? 'flip-list' : null">
						<div :key="1" :class="$style.outerStyle">
							<!-- 自訂題目標題列 -->
							<div :class="[$style.header]">
								<div :class="$style['header__title']">
									<el-button class="is-no-style"
										:class="[$style['header__angleButton'], closeIsActive ? '' : $style['header__angleButton__rotate']]"
										@click="openCloseCard">
										<BaseIcon name="angle-down" />
									</el-button>

									<span :class="$style['header__qTitle']">{{
										submitData.title === '' ? `問題標題` : submitData.title
									}}</span>
									<div :class="$style['header__rightUser']">
										<span>{{ typeSelect(submitData.type) }}</span>
										<el-switch :class="$style['header__rightUser__switch']" v-model="submitData.required"
											active-text="必填" inactive-text="非必填" :active-value="1" :inactive-value="0"
											style="width:160px;"></el-switch>
										<BaseIcon v-if="!submitData.default" name="grip-vertical" icon-style="fas"
											:class="[$style.drag, 'handle-subject']" />
										<el-tooltip v-else content="預設題目" placement="top">
											<BaseIcon name="lock-alt" :class="[$style.drag]" />
										</el-tooltip>
									</div>
								</div>
							</div>
							<!-- 自訂題目content -->
							<el-collapse-transition>
								<div :class="$style.content" v-if="closeIsActive">
									<el-form ref="form" :model="submitData" :rules="submitRules" label-position="top"
										class="el-form--floating">
										<el-row :gutter="20">
											<el-col :sm="12" :span="24">
												<el-form-item label="問題類型" prop="title" class="is-border is-padding is-round">
													<el-radio v-model="questionType" label="1">初次預約才需填寫</el-radio>
												</el-form-item>
											</el-col>
											<el-col :sm="12" :span="24">
												<el-form-item prop="title" class="is-border is-padding is-round is-empty-label">
													<span slot="label"></span>
													<el-radio v-model="questionType" label="2">每次預約需填寫</el-radio>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row :gutter="20">
											<el-col :sm="18" :span="24">
												<el-form-item label="問題標題" prop="title">
													<el-input v-model="submitData.title" placeholder="請輸入問題標題" class="bg-white is-border">
													</el-input>
												</el-form-item>
											</el-col>
											<el-col :sm="6" :span="24">
												<el-form-item label="回答形式" prop="type">
													<el-select v-model="submitData.type" @change="typeChanged" class="bg-white is-border">
														<el-option label="簡答" value="text"></el-option>
														<el-option label="單選" value="radio"></el-option>
														<el-option label="複選" value="checkbox"></el-option>
													</el-select>
												</el-form-item>
											</el-col>
										</el-row>

										<div :class="$style.footer">
											<el-row :gutter="20">
												<el-col :sm="12" :span="24">
													<el-button class="is-round is-full" @click="onClickButton('remove')">刪除</el-button>
												</el-col>
												<el-col :sm="12" :span="24">
													<el-button class="is-round is-full" :loading="loading" type="primary" @click="onClickSave">
														<BaseIcon name="check" />
														<span>儲存問題</span>
													</el-button>
												</el-col>
											</el-row>
										</div>
									</el-form>
								</div>
							</el-collapse-transition>
						</div>
					</transition-group>
				</draggable>
			</div>
		</div>
	</div>
</template>

<style lang="scss" module>

.outerStyle {
	border: 1px solid $color-line-dark;
	border-radius: $border-radius;
}

.stage {
	padding: 18px 20px;
	background-color: white;
}

.questionSet {
	margin-bottom: 11px;

	:global {
		.el-button {
			background-color: $color-primary;
			color: white;
			position: absolute;
			right: 10px;
		}
	}
}

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 2px solid $color-border-lighter;
	padding: 7px 20px;
	background-color: $color-line;
	border-top-left-radius: $border-radius;
	border-top-right-radius: $border-radius;

	h4 {
		display: inline-block;
		flex-shrink: 0;
	}

	&__title {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: space-between;
	}

	&__qTitle {
		padding-left: 20px;
		// width:360px;
	}

	&__angleButton {
		position: absolute;

		&__rotate {
			transform: rotate(180deg);
		}
	}

	&__rightUser {
		min-width: 290px;
		margin-left: 10px;
		display: flex;
		flex-grow: 1;
		justify-content: flex-end;
		align-items: center;

		&__switch {
			margin-right: 30px;
			margin-left: 30px;
		}

		@include max-md {
			flex-direction: column;
			justify-content: center;
			align-items: center;

			>* {
				margin-bottom: 10px;
			}
		}
	}

	[class*='fa-']+span {
		margin-left: 1.5em;
	}
}

.content {
	padding: 24px 21px;
}
</style>